// extracted by mini-css-extract-plugin
export default {"cls1":"SearchBar-cls1_MCL","cls2":"SearchBar-cls2_CAt SearchBar-cls1_MCL"};